import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { apiurl } from "../Constants";
import { fetchWishlists } from "./fetchwishListitem";

export const addToWishlist = createAsyncThunk(
  "wishlist/addToWishlist",
  async ({ product_id }, { dispatch, rejectWithValue }) => {
    try {
      const user_id = localStorage.getItem("userId");
      const payload = { user_id, product_id };
      const response = await axios.post(apiurl + "add_wishlist", payload);
      if (response.status === 200) {
        toast.success(" Item added to wishlist");
      }
      dispatch(fetchWishlists(user_id));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const RemoveWishlist = createAsyncThunk(
  "wishlist/RemoveWishlist",
  async ({ product_id }, { dispatch, rejectWithValue }) => {
    try {
      const user_id = localStorage.getItem("userId");
      const response = await axios.post(apiurl + "remove_wishlist", {
        user_id: user_id,
        product_id: product_id,
      });

      if (response.status === 200) {
        toast.error(" Product removed from wishlist");
        dispatch(fetchWishlists(user_id));
        return product_id; // Return the id to remove the item from local state
      }
      return rejectWithValue(response.data); // In case of error, return rejection data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(RemoveWishlist.fulfilled, (state, action) => {
        // Optimistically update the state to remove the item immediately
        state.items = state.items.filter((item) => item.id !== action.payload);
      })
      .addCase(RemoveWishlist.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchWishlists.fulfilled, (state, action) => {
        state.items = action.payload;
      });
  },
});

export default wishlistSlice.reducer;
